import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

type BannerSkeletonProps = {
  className?: string;
};

const BannerSkeleton = ({ className }: BannerSkeletonProps) => {
  return (
    <article
      className={cn("shrink-0 rounded-2xl p-1 border bg-white", className)}
    >
      <Skeleton className="w-full rounded-xl h-[142px]" />
    </article>
  );
};

export default BannerSkeleton;
